export default "__VITE_ASSET__391549c0__"